import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createUrl, get, post } from "../../network/AxiosInterceptor";
import { SingleTripView } from "./SingleTripView";
import { mapToCuratorCardViewModel } from "./CuratorCard/CuratorCardViewModel";
import { mapToSpotFormViewModel } from "./SpotForm/SpotFormViewModel";
import { mapToQuickDetailsViewModel } from "./Tabs/QuickDetails/QuickDetailsViewModel";
import { mapToItineraryViewModel } from "./Tabs/Itinerary/ItineraryViewModel";
import { SingleTripViewMobile } from "./mobile/SingleTripViewMobile";
import { useToast } from "../../components/ui/use-toast";

const SingleTripPage = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [tripName, setTripName] = useState("");
  const [tripTitle, setTripTitle] = useState("");
  const [tripDetailBgImg, setTripDetailBgImg] = useState("");
  const [mobileTripDetailBgImg, setMobileTripDetailBgImg] = useState([]);
  const [curatorViewModel, setCuratorViewModel] = useState({});
  const [spotFormViewModel, setSpotFormViewModel] = useState({});
  const [quickDetailsViewModel, setQuickDetailsViewModel] = useState({});
  const [itineraryViewModel, setItineraryViewModel] = useState({});
  const [tripOverview, setTripOverview] = useState([]);
  const [tripStays, setTripStays] = useState([]);
  const [vibeGallery, setVibeGallery] = useState([]);
  const [uniqueness, setUniquenes] = useState([]);
  const [location, setLocation] = useState("");
  const [bookingAmount,setBookingAmount] = useState(0);

  const { toast } = useToast();

  const { tripId } = useParams();

  const navigate = useNavigate();

  const tripRef = useRef(null);

  useEffect(() => {
    toast({}).dismiss();
    window.scrollTo(0, 0);
  }, []);

  const invalidTripId = !tripId || window.location.pathname.length <= 6;

  useEffect(() => {
    if (invalidTripId) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (!invalidTripId) {
      get(createUrl(`/api/trips/${tripId}`), {})
        .then((response) => {
          tripRef.current = response.data.trip;
          const a = response.data.trip.tripDates.length;
          let date = new Date();
          // date.setDate(date.getDate());
          response.data.trip.tripDates = response.data.trip.tripDates.filter(
            (tripDate) => tripDate.from > date
          );
          createSectionsVm(response.data.trip);
        })
        .catch(function (error) {
          console.log(error);
          navigate("/");
        });
    }
  }, []);

  const createSectionsVm = (trip) => {
    setTripName(trip.tripName);
    setTripTitle(trip.tripTitleLine);
    setTripDetailBgImg(trip.tripDetailBgImg);
    setCuratorViewModel(mapToCuratorCardViewModel(trip));
    setSpotFormViewModel(mapToSpotFormViewModel(trip));
    setQuickDetailsViewModel(mapToQuickDetailsViewModel(trip));
    setItineraryViewModel(mapToItineraryViewModel(trip));
    setTripOverview(trip?.tripOverview);
    setTripStays(trip?.tripStays);
    setVibeGallery(trip?.vibeGallery);
    setUniquenes(trip?.uniqueness);
    setLocation(trip?.location);
    setBookingAmount(trip?.bookingAmount*100);
    setShowLoader(false);
    if (trip?.mobileTripDetailBgImg.length > 0) {
      setMobileTripDetailBgImg(trip?.mobileTripDetailBgImg);
    } else {
      setMobileTripDetailBgImg([trip?.tripDetailBgImg]);
    }
  };

  const onFormSubmitted = (name, contactNumber, email, selectedDate) => {
    if (!name || !contactNumber || !email) {
      toast({
        title: "Exploro",
        description: "Please fill all details",
        variant: "destructive",
        position: "top-right",
      });
      return;
    }
    post(createUrl(`/api/leads`), {
      name: name,
      email: email,
      phone: contactNumber,
      selectedDate: selectedDate,
      tripId: tripRef.current.id,
    })
      .then((response) => {
        if (response.status === "error") {
          showToastOnSaveFailed();
          return;
        }
        showToastOnSaveSuccess();
        setTimeout(() => {
          navigate("/");
        }, 2500);
      })
      .catch(function (error) {
        console.log(error);
        showToastOnSaveFailed();
      });
  };

  const showToastOnSaveSuccess = () => {
    toast({
      title: "Exploro",
      description: "Booking Request Submitted",
      variant: "payment_complete",
    });
  };

  const showToastOnSaveFailed = () => {
    toast({
      title: "Exploro",
      description: "Not able to Submit the Request",
      variant: "destructive",
    });
  };

  const initiatePayment = (name, phone, email) => {
    if(bookingAmount==0)return;
    const pageUrl = window.location.href;
    const pageUrlSplit = pageUrl.split('/');
    const pageUrlId = pageUrlSplit[pageUrlSplit.length-1];
    post(createUrl(`/api/payment/initiate/${pageUrlId}`), {
      bookingAmount,
      name,
      phone,
      email,
      pageUrl,
    }).then(res=>{
      console.log(res,'res');
    }).catch(err=>{
      console.log(err,'err');
    });
  };

  return (
    <div>
      <div className="hidden lg:block">
        <SingleTripView
          showLoader={showLoader}
          tripName={tripName}
          tripTitle={tripTitle}
          tripDetailBgImg={tripDetailBgImg}
          curatorViewModel={curatorViewModel}
          spotFormViewModel={spotFormViewModel}
          quickDetailsViewModel={quickDetailsViewModel}
          itineraryViewModel={itineraryViewModel}
          onFormSubmitted={onFormSubmitted}
          initiatePayment={initiatePayment}
        />
      </div>

      <div className="lg:hidden">
        <SingleTripViewMobile
          showLoader={showLoader}
          tripName={tripName}
          tripTitle={tripTitle}
          tripDetailBgImg={tripDetailBgImg}
          mobileTripDetailBgImg={mobileTripDetailBgImg}
          curatorViewModel={curatorViewModel}
          spotFormViewModel={spotFormViewModel}
          quickDetailsViewModel={quickDetailsViewModel}
          itineraryViewModel={itineraryViewModel}
          tripOverview={tripOverview}
          tripStays={tripStays}
          vibeGallery={vibeGallery}
          uniqueness={uniqueness}
          location={location}
          onFormSubmitted={onFormSubmitted}
          initiatePayment={initiatePayment}
        />
      </div>
    </div>
  );
};

export default SingleTripPage;
